const APPROVER = 1;
const REVIEWER = 2;
const SIGNER = 3;
const VIEWER = 4;
const CONFIGURATOR = 5;

export default {
  APPROVER,
  REVIEWER,
  SIGNER,
  VIEWER,
  CONFIGURATOR
};
